import React from 'react';
import SEO from "../common/SEO";
import Layout from '../common/Layout';
import { FiCheck ,  } from 'react-icons/fi';
import SectionTitle from '../elements/sectionTitle/SectionTitle';
import TabOne from '../elements/tab/TabOne';
import CalltoActionFive from '../elements/calltoaction/CallToActionFive';
import ServiceSB from '../elements/service/ServiceSB';

const About = () => {
    return (
        <>
            <SEO title="About IEEE ISSAT Sousse || About IEEE ISSATSo" />
            <main className="page-wrapper">
                <Layout>
                     {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 bg-transparent height-720">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-7 col-xl-6 order-2 order-lg-1 mt_md--40 mt_sm--40">
                                <div className="inner text-left">
                                    <h1 className="title HighTitles display-one">Get to know us</h1>
                                    <ul className="list-icon">
                                        <li><span className="icon"><FiCheck /></span> We aim to make great achievements.</li>
                                        <li><span className="icon"><FiCheck /></span> Sharing knowledge is our Goal.</li>
                                        <li><span className="icon"><FiCheck /></span> Promoting Technology and Creativity is The result of our hard work.</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-5 col-xl-6 order-2 order-lg-2 mt-4">
                                <div className="frame-image">
                                    <img src="./images/about/AboutPage4.jpg" alt="Banner Images" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    {/* End Slider Area  */}
                    {/* Starting Introducing Our current program */}
                    <div className="rn-service-area rn-section-gap ">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "About our Activities"
                                        title = "Student Branch Activities"
                                        description = ""
                                     />
                                </div>
                            </div>
                            <ServiceSB 
                                serviceStyle = "service__style--1 bg-color-blackest radius mt--25"
                                textAlign = "text-center"
                             />
                        </div>
                    </div>
                    {/* Ending Introducing Our current program */}
                    {/* Starting Introducing IEEE */}
                    <div className="rwt-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "let's break the ice"
                                    title = "Learn more about IEEE"
                                    description = "We are glad to know that you are interested in Knowing more </br> about our organisation"
                                />
                                
                            </div>
                        </div>
                        <TabOne />
                    </div>
                </div>
                    {/* Ending Intro IEEE */}
                    {/*Start what we guarantee For you*/}
                    <CalltoActionFive />
                    {/* Ending what we guarantee For you*/}
                    
                    
                    


                </Layout>
            </main>
        </>
    )
}

export default About;